export enum DateTimeFormatStrings {
  FORMAT_1 = "YYYY-MM-DD",
  FORMAT_2 = "MM-yyyy",
  FORMAT_3 = "DD.MM.YYYY",
  FORMAT_4 = "DD/MM/YYYY",
  FORMAT_5 = "YYYYMM",
  FORMAT_6 = "yyyy-MM-dd",
  FORMAT_7 = "YYYYMMDD",
  FORMAT_8 = "HH:mm:ss",
  FORMAT_9 = "YYYY-MM-DD HH:mm:ssXXX", // Add Time Zone
  FORMAT_10 = "YYYY-MM-DDT00:00:00Z", // Only have date value
  FORMAT_11 = "YYYY-MM-DDTHH:mm:ssZ",
  FORMAT_12 = "YYYY-MM-DD HH:mm:ss",
  FORMAT_13 = "MM/DD/YYYY",
  FORMAT_14 = "MM/DD/YYYY HH:mm:ss A",
}

export enum CustomerAttributeConstraintType {
  UOM = "UOM",
  SalesOrg = "SalesOrg",
  Currency = "Currency",
  SAPMaterialProductCode = "SAPMaterialProductCode",
  SAPEnergySurchargeCode = "SAPEnergySurchargeCode",
}

export enum SurchargeType {
  Energy = "Energy",
  Product = "Product",
}

export enum CalculationResultErrorTypes {
  NoError = 0,
  ParseError = 1,
  SoftError = 2,
  HardError = 3,
}

export enum ProductLines {
  Nitrogen = "Nitrogen",
  Oxygen = "Oxygen",
  Helium = "Helium",
  Hydrogen = "Hydrogen",
  Argon = "Argon",
  CO2 = "CO2",
}

export enum SurchargeEventTypeCode {
  Monthly = "Monthly",
  Quarterly = "Quarterly",
  AdHoc = "Ad-Hoc",
}

export enum DialogType {
  info,
  warning,
  error,
}
